import { useEffect, useState } from "react";
import { DeviceMobile, X } from "@phosphor-icons/react";

let deferredPrompt = null;
if (typeof window !== "undefined") {
    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        deferredPrompt = e;
    });
}

export const InstallAppButton = ({ testid = "install-app-btn" }) => {
    const [showHelp, setShowHelp] = useState(false);
    const [installed, setInstalled] = useState(false);

    useEffect(() => {
        if (window.matchMedia("(display-mode: standalone)").matches) setInstalled(true);
        const onInstalled = () => setInstalled(true);
        window.addEventListener("appinstalled", onInstalled);
        return () => window.removeEventListener("appinstalled", onInstalled);
    }, []);

    const onClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === "accepted") setInstalled(true);
            deferredPrompt = null;
        } else {
            setShowHelp(true);
        }
    };

    if (installed) {
        return (
            <span
                data-testid={`${testid}-installed`}
                className="text-xs text-green-700 border border-green-600 px-3 py-2 flex items-center gap-1"
            >
                <DeviceMobile size={14} weight="fill" /> Sudah terpasang di HP
            </span>
        );
    }

    return (
        <>
            <button
                data-testid={testid}
                onClick={onClick}
                className="text-xs text-primary border border-primary px-3 py-2 hover:bg-primary hover:text-primary-foreground transition-colors flex items-center gap-1"
            >
                <DeviceMobile size={14} weight="light" /> Pasang di Layar Utama HP
            </button>
            {showHelp && (
                <div
                    className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-4"
                    onClick={() => setShowHelp(false)}
                    data-testid="install-help-overlay"
                >
                    <div className="bg-white w-full max-w-sm p-5 space-y-3 relative" onClick={(e) => e.stopPropagation()}>
                        <button
                            data-testid="install-help-close"
                            onClick={() => setShowHelp(false)}
                            className="absolute top-3 right-3 text-muted-foreground hover:text-primary"
                        >
                            <X size={18} />
                        </button>
                        <p className="font-medium text-sm" data-testid="install-help-title">
                            Pasang INERRE ke layar utama HP
                        </p>
                        <div className="text-xs text-muted-foreground space-y-2 leading-relaxed">
                            <p>
                                <span className="font-medium text-foreground">Android (Chrome):</span> ketuk menu{" "}
                                <span className="font-medium">⋮</span> di kanan atas → pilih{" "}
                                <span className="font-medium">"Instal aplikasi"</span> atau{" "}
                                <span className="font-medium">"Tambahkan ke layar utama"</span>.
                            </p>
                            <p>
                                <span className="font-medium text-foreground">iPhone (Safari):</span> ketuk tombol{" "}
                                <span className="font-medium">Share</span> →{" "}
                                <span className="font-medium">"Add to Home Screen"</span>.
                            </p>
                            <p>
                                Setelah terpasang, tekan-tahan ikon INERRE untuk pintasan cepat{" "}
                                <span className="font-medium">Kantor</span>, <span className="font-medium">Workshop</span>, dan{" "}
                                <span className="font-medium">Admin</span> — juga bisa dicari lewat pencarian aplikasi di HP.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
